import { Assert } from '@team/assert';

export const formatNumber = (languageCode = 'en') => {
  const formatter = new Intl.NumberFormat(languageCode, {
    maximumFractionDigits: 1,
  });

  return (value: number) => {
    if (!Assert.isNumber(value)) {
      return String(value);
    }

    if (value >= 1_000_000) {
      return formatter.format(value / 1_000_000) + 'M';
    } else if (value >= 1_000) {
      return formatter.format(value / 1_000) + 'K';
    }

    return formatter.format(value);
  };
};
